var _style, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttackGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:none;stroke:#000;stroke-miterlimit:10}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 7,
    cy: 11,
    r: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3 9.8h2.4v2.4H1.3zM10.3 9.8h2.4v2.4h-2.4zM9.1 6.5h2.4v2.4H9.1zM2.5 13.1h2.4v2.4H2.5zM9.1 13.1h2.4v2.4H9.1zM2.5 6.5h2.4v2.4H2.5zM.5 1.5h2.4v2.4H.5zM11.5 4.1h2.4v2.4h-2.4zM11 16.7h2.4v2.4H11zM.1 15.5h2.4v2.4H.1zM15.6.4H18v2.4h-2.4zM15.6 7.7H18v2.4h-2.4zM17.6 17.6H20V20h-2.4zM5.8 17.6h2.4V20H5.8zM7.9 0h2.4v2.4H7.9zM5.8 14.3h2.4v2.4H5.8zM5.8 5.3h2.4v2.4H5.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.8 18.8l-8.5-4.5 1.9 3.6M16.8 8.9L11.5 11M16.8 1.6L10 7.7M7 15.5c.2.3 0 3.4 0 3.4M3.7 14.3l-2.4 2.4M3.7 7.7l-2-5.1M7 6.5l2.1-5.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttackGraph);
export default __webpack_public_path__ + "static/media/attack-graph.24f68418.svg";
export { ForwardRef as ReactComponent };